/** Height threshold that determines icon size to be small or medium */
export var ICON_SIZE_THRESOLD = 24;